/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tradeBuy.vue?vue&type=template&id=7e16d6c8&scoped=true&"
import script from "./tradeBuy.vue?vue&type=script&lang=js&"
export * from "./tradeBuy.vue?vue&type=script&lang=js&"
import style0 from "./tradeBuy.vue?vue&type=style&index=0&id=7e16d6c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16d6c8",
  null
  
)

export default component.exports